
export const SET = 'one-state-errorhandle/set';
export const SETNOTIFICATION = 'one-state-errorhandle/setnotification';
export const RESET = 'one-state-errorhandle/reset';